/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  appCardListPlugin,
  IappCardListPluginMethods,
  ErrorHolderDetailPlugin,
  IErrorHolderDetailPluginMethods,
  featureHolderDetailPlugin,
  IfeatureHolderDetailPluginMethods,
  FooterHolderDetailPlugin,
  IFooterHolderDetailPluginMethods,
  HeaderHolderDetailPlugin,
  IHeaderHolderDetailPluginMethods,
  LoadingHolderDetailPlugin,
  ILoadingHolderDetailPluginMethods,
  settingsHolderDetailPlugin,
  IsettingsHolderDetailPluginMethods,
  staticHolderDetailPlugin,
  IstaticHolderDetailPluginMethods,
  updateKYCStatusPlugin,
  IupdateKYCStatusPluginMethods,
} from './plugins';

export type TAgent = IappCardListPluginMethods &
  IErrorHolderDetailPluginMethods &
  IFooterHolderDetailPluginMethods &
  IHeaderHolderDetailPluginMethods &
  ILoadingHolderDetailPluginMethods &
  IfeatureHolderDetailPluginMethods &
  IsettingsHolderDetailPluginMethods &
  IstaticHolderDetailPluginMethods &
  IupdateKYCStatusPluginMethods;
const getPlugins = () => {
  return [
    new staticHolderDetailPlugin(),
    new ErrorHolderDetailPlugin(),
    new LoadingHolderDetailPlugin(),
    //Business logic plugins !
    new appCardListPlugin(),
    new featureHolderDetailPlugin(),
    new FooterHolderDetailPlugin(),
    new HeaderHolderDetailPlugin(),
    new settingsHolderDetailPlugin(),
    new updateKYCStatusPlugin(),
    new updateKYCStatusPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
